export default __webpack_public_path__ + "static/media/piramis.da51f1d5.obj";